module.exports = __webpack_public_path__ + "img/pre_max.45f6dde3.png";